import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HelpDialog } from 'src/app/data/models/dto/help-dialog.dto';

@Component({
  // selector: 'app-help-dialog',
  templateUrl: './help-dialog.component.html',
  styleUrls: ['./help-dialog.component.scss']
})
export class HelpDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<HelpDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public helpDialog: HelpDialog
  ) { }

  ngOnInit(): void {
  }
  
  onClick() {
    this.dialogRef.close();
  }
}
